<template>
  <div class="login" id="login">
    <!--
    <div>
      <div class="login_card">
        <div class="login_name">系统登录</div>
        <div class="login_input_box ms-content">
          <div class="username_div">
            <el-input prefix-icon="iconfont icon-login-username"  v-model="username" placeholder="用户名">
            </el-input>
          </div>
          <div class="password_div">
            <el-input prefix-icon="iconfont icon-login-password" class="iconStyle" v-model="password" placeholder="密码" type="password">
            </el-input>
          </div>
           <div class="login-btn">
              <el-button size="medium" @click="login" type="primary">登录</el-button>
           </div>
        </div>
      </div>
    </div>
    -->
    <div class="mainFrame">
      <div class="titlePanel">
        <span class="login_title_ch">中国消防协会会员管理系统</span>
        <span class="login_title_en">Member Management System</span>
      </div>
      <div class="welcomePanel">
        <div class="welcomeLable">
          <label>WELCOME</label>
        </div>
        <div class="city_pic"></div>
        <div class="loginPanel" style="position: relative;">
          <LoginMain ref="loginmain" v-show="isLogin"></LoginMain>
          <RegisterMain ref="registermain" v-show="isRegister"></RegisterMain>
          <ForgetPassword ref="forgetpasswordmain" v-show="isForgot"></ForgetPassword>
          <ForgetUsername ref="forgetusernamemain" v-show="isForgotUsername"></ForgetUsername>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
var code ; //在全局定义验证码

import LoginMain from "@/views/login/LoginMain";
import RegisterMain from "@/views/login/RegisterMain";
import ForgetPassword from "@/views/login/ForgetPassword";
import ForgetUsername from "@/views/login/ForgetUsername";

export default {
    name: 'Login',
    components: {
      LoginMain: LoginMain,
      RegisterMain: RegisterMain,
      ForgetPassword: ForgetPassword,
      ForgetUsername: ForgetUsername,
    },
  data(){
    return {
      isLogin:true,
      isRegister:false,
      isForgot:false,
      isForgotUsername:false,
      userName:"",
    }
  },
  //实现窗口自适应 add by yushch 20191227
  mounted(){
    let htmlWidth = document.documentElement.clientWidth ||document.body.clientWidth;
		//获取htmlDom
		let htmlDom = document.getElementsByTagName('html')[0];
		//设置html的font-size
		htmlDom.style.fontSize = htmlWidth/120+'px';
		window.addEventListener('resize',(e)=>{
			let htmlWidth = document.documentElement.clientWidth ||document.body.clientWidth;
			//获取htmlDom
			let htmlDom = document.getElementsByTagName('html')[0];
			//设置html的font-size
			htmlDom.style.fontSize = htmlWidth/120+'px';
		})
  },
  created(){

  },
  methods:{
  checkRegister:function(){
    this.isLogin = false;
    this.isRegister = true;
    this.isForgot = false;
    this.isForgotUsername = false;
    this.$refs.registermain.init();
  },
  checkLogin:function(){
    this.isLogin = true;
    this.isRegister = false;
    this.isForgot = false;
     this.isForgotUsername = false;
     this.$refs.loginmain.init();
  },
  checkForgot:function(){
    this.isLogin = false;
    this.isRegister = false;
    this.isForgot = true;
     this.isForgotUsername = false;
     this.$refs.forgetpasswordmain.init();
  },
  checkForgotUsername:function(){
    this.isLogin = false;
    this.isRegister = false;
    this.isForgot = false;
    this.isForgotUsername = true;
    this.$refs.forgetusernamemain.init();
  },
  }
};
</script>

<style lang="scss">
@font-face {
	font-family:'PingFangRegular';
	src: url(../../../static/fonts/iconfont/PingFangRegular.ttf);
}
@font-face {
	font-family:'SourceHanSansSCReqular';
	src: url(../../../static/fonts/iconfont/SourceHanSansSC-Regular.otf);
}
#login{
  width: 100vw;
  height: 100vh;
  //background: url(../../../static/images/login/login_bg.jpg);
  //background-size: 100%;
  background-repeat: no-repeat;

  //mofify by yushch
  background: url(../../../static/images/login/pic_bg.png);
  background-size: cover;
  display:flex;
  justify-content:center;
  align-items:center;

  .login-btn{
    text-align: center;
    position: absolute;
    bottom:0;
    width: 100%;
  }
  .login-btn button{
    width:100%;
    //  height:36px;
    height:2.8rem;
    border-top-left-radius:.375rem;
    border-top-right-radius:.375rem;
    border-bottom-right-radius:1.625rem;
    border-bottom-left-radius:1.625rem;
    font-family: 'PingFangRegular';
    font-size:1rem;
  }
  .mainFrame{
     transform:translateY(-1rem);
   }
  .welcomePanel{
    background-color: #ffffff;
    height: 33.75rem;
    width: 65rem;
    border-radius: .625rem;
  }
  .city_pic{
    background: url(../../../static/images/login/pic_city.png);
    background-size: cover;
    width: 56.25rem;
    height: 36.125rem;
    position: absolute;
    margin-left: -16.25rem;
    margin-top: .1875rem;
  }
  .welcomeLable{
    color: #006dbe;
    position: absolute;
    padding-top: .875rem;
    padding-left: 1rem;
    font-size: 1.25rem;
    font-family: 'Arial';
    line-height: 1;
  }
  .loginPanel{
    height: 29rem;
    width: 20rem;
    float: right;
    margin-top: 2rem;
    margin-right: 3.75rem;
    text-align: center;
    position: relative;
  }
  .loginLable{
    font-size: 1.75rem;
    color: #333333;
    font-family: 'PingFangRegular';
  }
  .el-input__inner {
      width: 100%;
      border-top-width: 0px !important;
      border-left-width: 0px !important;
      border-right-width: 0px !important;
      border-bottom-width: .0625rem !important;
      border-bottom-color: #666666 !important;
      border-radius: 0 !important;
      /*outline: medium;*/
      padding-left: 0 !important;
      height: 3rem !important;
  }
  .password_div1{
    position: absolute;
    bottom:11.875rem;
    width: 100%;
  }
  .username_div1{
    position: absolute;
    bottom:16.25rem;
    width: 100%;
  }
  .verification_div{
    position: absolute;
    bottom: 7.5rem;
    width: 100%;
  }
  .titlePanel {
    line-height: 1;
    margin-bottom: 1.25rem;
  }
  .login_title_ch {
    font-family: 'SourceHanSansSCReqular';
    font-size: 2.25rem;
    color: #ffffff;
    text-shadow:0.1em 0.1em 0.3em #333333;
  }
  .login_title_en {
    margin-left: 1.25rem;
    font-family: 'PingFangRegular';
    font-size: 1.375rem;
    color: #ffffff;
    text-shadow:0.1em 0.1em 0.3em #333333;
  }
  .el-form-item__error {
    padding-top: .625rem;
    font-size: .875rem !important;
    z-index: 1000 !important;
  }
  .verification1{
    width:7.125rem;
    height:3.125rem;
    border: none;
    border-radius: .3125rem;
    font-size: 1.75rem;
    color: #F89E19;
    font-family: 'PingFangRegular';
    text-shadow:0.05em 0.05em 0.3em #333333;
    float: right;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }
  input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      color:#666666 !important;
      font-size: .875rem !important;
      font-family: 'PingFangRegular' !important;
   }
   input::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color:#666666 !important;
      font-size: .875rem !important;
      font-family: 'PingFangRegular' !important;
   }
   input:-moz-placeholder { /* Mozilla Firefox 19+ */
      color:#666666 !important;
      font-size: .875rem !important;
      font-family: 'PingFangRegular' !important;
   }
   input:-ms-input-placeholder { /* Internet Explorer 10-11 */
      color:#666666 !important;
      font-size: .875rem !important;
      font-family: 'PingFangRegular' !important;
   }
   .yzmbtn{
     width: 33%;
     color: #409eff;
     font-size: 0.9375rem;
     background-color: #ffffff;
     border-radius: 4px;
   }
   .titleline{
     margin-top: 10px;
     font-size: 1rem;
     color: #409eff;
     display: inline-block;
     width: 100%;
     height: auto;
     text-align: right;
   }
}
</style>



// WEBPACK FOOTER //
// src/views/common/Login.vue